<template>
	<div class="sy-ch-main container-fluid">
		<h1 class = "mb3">History</h1>
		<!-- <div class="sy-ch-search mb3">
			<input class="form_control" type="text" name="" value="" placeholder="Search" v-model = "orderID"  v-on:keyup.enter = "search(orderID)">
			<button class="sy-se-icon" @click = "search(orderID)"><img src="../../static/img/search.png" width="18" alt=""></button>
		</div> -->
		<ul v-if = "searching">
			<div style = "cursor: pointer; text-align: center;" @click = "back">
				<h1>Back to Orders</h1>
			</div>
			<h1>Search results: {{calcNOrders(searchedOrder)}}</h1>
			<li v-for = "(dayOrders, date) in searchedOrder">
				<h1 class = "mb1">{{date}}</h1>
				<ul class="sy-ml-list" v-for = "order in dayOrders">
					<li>
						<div v-bind:class="{'sy-ml-box': 1==1,  selected: order.Redeemed}">
							<div>
								<p><strong>{{order["Order ID"]}}</strong></p>
								<p class="sy-ms-tag">{{calcTotal(order.Items)}}</p>
							</div>
							<div>
								<p><strong>{{order.Name}}</strong></p>
								<p class="sy-ms-tag">{{order["Contact Number"]}}</p>
								<p class="sy-ms-tag">{{order["Email"]}}</p>
								<p class="sy-ms-tag" v-if = "order['Collection Mode'] == 'Delivery'">{{order["Address"]}}</p>
								<strong class="sy-ms-tag">Total: RM {{formatPrice(order.Total, "")}}</strong>
								<div class="mt1">
									<div v-for = "item in order.Items">
										(RM {{formatPrice(item['Total'] || item.Quantity*item.Price, "")}}) {{item.Quantity}} x {{item.Name}}
										<div v-html = "generateHTML(item)"></div>
									</div>
								</div>
								<div class="mgt-15 text-right" >
									<div class="sy-ms-btn bp-set mb1" v-if = "!order.Paid" @click = "deleteOrder(order)">Delete Order</div>
									<div class="sy-ms-btn bp-set" @click = "redeem(order)">{{formatTime(order.Date)}}</div>
								</div>
							</div>
						</div>
					</li>
				</ul>
			</li>
			
		</ul>
		<ul class="sy-ma-list2 com_sy-boxes" v-else>
			<li v-for = "(dayOrders, date) in sortedOrders">
				<h1 class = "mb1">{{date}}</h1>
				<ul class="sy-ml-list" v-for = "order in dayOrders">
					<li>
						<div v-bind:class="{'sy-ml-box': 1==1,  selected: order.Redeemed}">
							<div>
								<p><strong>{{order["Order ID"]}} <div style = "display: inline-block">({{order["Collection Mode"] || "Pickup"}})</div></strong></p>
								<p class="sy-ms-tag">{{calcTotal(order.Items)}}</p>
							</div>
							<div>
								<p><strong>{{order.Name}}</strong></p>
								<p class="sy-ms-tag">{{order["Contact Number"]}}</p>
								<p class="sy-ms-tag">{{order["Email"]}}</p>
								<p class="sy-ms-tag" v-if = "order['Collection Mode'] == 'Delivery'">{{order["Address"]}}</p>
								<strong class="sy-ms-tag">Total: RM {{formatPrice(order.Total, "")}}</strong>
								<div class="mt1">
									<div v-for = "item in order.Items">
										(RM {{formatPrice(item['Total'] || item.Quantity*item.Price, "")}}) {{item.Quantity}} x {{item.Name}}
										<div v-html = "generateHTML(item)"></div>
									</div>
								</div>
								<div class="mgt-15 text-right" >
									<div class="sy-ms-btn bp-set mb1" v-if = "!order.Paid" @click = "deleteOrder(order)">Delete Order</div>
									<div class="sy-ms-btn bp-set" @click = "redeem(order)">{{formatTime(order.Date)}}</div>
								</div>
							</div>
						</div>
					</li>
				</ul>
			</li>
		</ul>

		<div class="mgt-15 text-right" @click = "getMoreOrders" v-if = "!noNewOrders">
			<div class="sy-ms-btn bp-set">Load More</div>
		</div>
	</div>
</template>
<script>
var dbPath;
export default{
	data(){
		return{
			orders: [],
			sortedOrders: {},
			todayOrders: [],
			searching: false,
			orderID: "",

			searchedOrder: {},
			nOrders: 10,
			noNewOrders: false
		}
	},
	firestore(){
		dbPath = "business/" + this.$route.params.businessID + "/preorders";
		var today = new Date();
		today.setSeconds(0);
		today.setMinutes(0);
		today.setHours(0);
		var todayTime = today.getTime();
		var tomorrowTime = todayTime + 24*60*60*1000;
		this.getOrders();
		customJS.runAll();
	},
	watch:{
		orders: function(){
			this.sortOrders();
		},
	},
	methods:{
		generateHTML(item){
			var i = myCopier.copy(item);
			var code = "";
			if (item.custom != undefined && item.custom.length > 0){
				code += "<div style = \"padding-left: 5px;\">\n";
				item.custom.forEach((c, cIndex)=>{
					code += (cIndex+1) + ": \n";
					code += "<div style = \"padding-left: 5px;\">\n";
					for (var optionIndex in c){
						var option = c[optionIndex];
						if (option.length > 0){
							code += "<li>- " + optionIndex + ": \n";
							option.forEach((choice, choiceIndex)=>{
								code += "<span>\n" + choice + "\n";
								if (choiceIndex < option.length-1){
									code += "<span>, </span>\n";
								}
								code += "</span>\n";
							});
							code += "</li>\n";
						}
					}
					code += "</div>\n"
				})
				code += "</div>\n";
			}
			return code;
		},
		//------------------------ DISPLAY ------------------------//
		formatTime(input){
			return myDate.displayDateTime(input,
			{
				sequence: "d-m-y",
			},
			{
				hourFormat: 12,
				sequence: "hh:mm",
			})
		},
		calcTotal(items){
			// console.log(items);
			var total = 0;
			items.forEach(i=>{
				// console.log(i);
				total += i.Quantity*i.Price;
			})
			// var Tax = total*0.06;
			// this.Total = total + Tax;
			this.Total = total;
			return this.Total;
		},
		formatPrice(input, prefix){
			var prefix = prefix || "";
			return myPrice.display(input, prefix)
		},


		//------------------------ SORTING ------------------------//
		getOrders(){
			myFB.db.collection(dbPath).orderBy("Date", "desc").where("Redeemed","==",true).limit(this.nOrders).get().then(r=>{
				var allOrders = [];
				r.docs.forEach(d=>{
					allOrders.push(d.data());
				})
				this.orders = allOrders;
				this.sortOrders();
				customJS.runAll();

				if (r.docs.length < this.nOrders){
					this.noNewOrders = true;
				}
			})
			// var allOrders = [];
			// for (var i = 0; i < this.nOrders; i++){
			// 	if (i < this.$parent.allOrders.length && this.$parent.allOrders[i].Redeemed){
			// 		allOrders.push(this.$parent.allOrders[i])
			// 	}
			// }
			// this.orders = allOrders;
		},
		getMoreOrders(){
			myFB.db.collection(dbPath).orderBy("Date", "desc").where("Redeemed","==",true).startAfter(this.orders[this.orders.length-1].Date).limit(this.nOrders).get().then(r=>{
				var allOrders = [];
				this.orders.forEach(d=>{
					allOrders.push(d);
				})
				r.docs.forEach(d=>{
					allOrders.push(d.data());
				})

				this.orders = allOrders
				this.sortOrders();

				if (r.docs.length < this.nOrders){
					this.noNewOrders = true;
				}
			})
			// this.nOrders += 10;
			// var allOrders = [];
			// for (var i = 0; i < this.nOrders; i++){
			// 	if (i < this.$parent.allOrders.length && this.$parent.allOrders[i].Redeemed){
			// 		allOrders.push(this.$parent.allOrders[i])
			// 	}
			// }
			// if (allOrders.length == this.orders.length){
			// 	this.noNewOrders = true;
			// }
			// this.orders = allOrders;
		},
		sortOrders(){
			var today = new Date();
			today.setSeconds(0);
			today.setMinutes(0);
			today.setHours(0);
			var todayTime = today.getTime();

			var sortedOrders = {}
			var dateNow = "";

			this.orders.forEach(r=>{
				dateNow = myDate.displayDate(r.Date,{sequence: "d m", monthMode: 2})
				if (sortedOrders[dateNow] == undefined){
					sortedOrders[dateNow] = [r];
				}
				else{
					sortedOrders[dateNow].push(r);
				}
			})
			this.sortedOrders = sortedOrders;
		},
		redeem(item){
			myFB.db.collection("orders").doc(item.ID).update({
				Redeemed: !item.Redeemed
			})
		},
		deleteOrder(item){
			if (confirm("Confirm deleting order " + item["Order ID"] + " for " + item.Name + "?")){
				myFB.deleteDoc("orders", item['.key'], this, "Deleting order " + item["Order ID"] + " for " + item.Name + "...", "Order deleted!");
			}
		},

		search(orderID){
			myFB.db.collection("orders").where("Order ID", "==", orderID).get().then(r=>{
				var  dateNow = myDate.displayDate(r.docs[0].data().Date,{
					separator: "-",
					sequence: "ddmmyyyy",
					monthMode: 2,
					showDate: 1,
					showMonth: 1,
					showYear: 1,
				})
				var searchedOrder = {};
				searchedOrder[dateNow] = [r.docs[0].data()];
				this.searchedOrder = searchedOrder
				this.searching = true;
			})
		},
		back(){
			this.searching = false;
			this.orderID = "";
		},
		calcNOrders(sOrders){
			var num = 0;
			for (var item in sOrders){
				num += sOrders[item].length;
			}
			return num;
		}

	}
}
</script>


// WEBPACK FOOTER //
// src/components/History.vue